import { clsx } from '@appvantageasia/core-utils';
import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { NavigateItem } from '../types';

export const isPathnameMatch = (target: string, pathname: string): boolean => {
    return pathname === target || pathname.startsWith(`${target}/`);
};

const ItemWrapper = ({ item, children }: { item: NavigateItem; children: ReactNode }) => {
    const { path } = item;
    const location = useLocation();
    const { pathname } = location;

    const style = clsx(
        'flex w-full text-left cursor-pointer gap-3 rounded-md px-[10px] py-3 text-sm font-medium capitalize',
        {
            'bg-primary text-primary-foreground': path && isPathnameMatch(path, pathname),
            'text-default-600': path && !isPathnameMatch(path, pathname),
        }
    );

    if (path) {
        return (
            <Link to={path} data-cy={`sidebarMenuItem-${item.key}`} className={style}>
                {children}
            </Link>
        );
    }

    return (
        <button className={style} onClick={item.onClick}>
            {children}
        </button>
    );
};

const SubMenuItem = ({ item }: { item: NavigateItem }) => {
    return (
        <div className="flex-1">
            <ItemWrapper item={item}>
                {item?.icon && (
                    <span className="inline-flex grow-0 items-center">
                        <item.icon className="h-4 w-4" />
                    </span>
                )}
                <div className="grow truncate">{item.name}</div>
            </ItemWrapper>
        </div>
    );
};

export default SubMenuItem;
